module.exports = function() { return __webpack_public_path__ + "when-traveling-xs@2x.GTsvORL5mYO5JPoOO2OB.png";};